// Placeholder glyphs for the "Symbols" display mode -- opaque marks standing in for
// the real visual glyph system, which design/07_Open_Questions.md flags as an agreed
// principle with no actual glyph design work started yet ("The visual glyph system
// itself... is an agreed principle but no actual glyph design work has started").
// Deliberately arbitrary and meaningless: unlike the Shorthand codes (rune-lab's
// shorthand.ts), nothing here should hint at what a rune does -- that's the whole
// point of this mode, per the "preserve mystery" pillar in design/01_Vision.md.
export const RUNE_SYMBOL: Record<string, string> = {
  // Concepts
  energy: 'α',
  space: 'β',
  charge: 'γ',
  momentum: 'δ',
  entropy: 'ε',
  time: 'ζ',
  mass: 'η',

  // Operators
  transfer: 'θ',
  convert: 'ι',
  bind: 'κ',
  separate: 'λ',
  measure: 'μ',
  project: 'ν',

  // Modifiers
  reverse: 'ξ',
  small: 'σ',
  unbound: 'υ',
  continuous: 'φ',
  radial: 'χ',
  linear: 'ψ',
  oscillating: 'ω',
  maximum: 'Ω',
};
